export default __webpack_public_path__ + "static/media/person_1@2x.11eaaa74.png";